import HeaderBanner from './HeaderBanner';
import VenteBanner from './VenteBanner';
import MecaBanner from './MecaBanner';
import AnalysesBanner from './AnalysesBanner';
import AnalysesIcon from './AnalysesIcon';

export { HeaderBanner, VenteBanner, MecaBanner, AnalysesBanner, AnalysesIcon };



// WEBPACK FOOTER //
// ./src/components/Main/services/index.js